// extracted by mini-css-extract-plugin
export default {"toggle":"lE_lF","toggle_small":"lE_lG","toggle_large":"lE_lH","toggle_disabled":"lE_lI","toggle__input":"lE_lJ","toggle__track":"lE_lK","toggle__handle":"lE_lL"};